import React from 'react';
import { Swiper } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
import { FaCar, FaMapMarkerAlt } from "react-icons/fa"
import { MdBathroom, MdBedroomChild } from "react-icons/md";
import Button from "../../components/Button"
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';

import {
  Container,
  Slide,
  SwiperWrapper,
  InfoPrincipal,
  Titulo,
  Endereco,
  Preco,
  Detalhes,
  DetalheItem,
  Acoes,
  Descricao,
  Localizacao
} from './styles';

const ImovelPage = ({ imovel }) => {
  if (!imovel) return null;

  const icon = new Icon({
    iconUrl: require("../../assets/mapa.png"),
    iconSize: [38, 38] // size of the icon
  });

  return (
    <Container>
      <SwiperWrapper>
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={10}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
        >
          {imovel.imagens.map((foto, index) => (
            <Slide key={index}>
              <img src={`${process.env.REACT_APP_API_URL}/${foto.caminho}`} alt={`Foto ${index + 1}`} />
            </Slide>
          ))}
        </Swiper>
      </SwiperWrapper>

      <InfoPrincipal>
        <Titulo>{imovel.tipo}</Titulo>
        <Endereco><FaMapMarkerAlt size={24} /> {imovel.endereco}</Endereco>
        <Preco>R$ {imovel.valor.toLocaleString('pt-BR')}</Preco>

        <Detalhes>
          {/* <DetalheItem>{imovel.area} m²</DetalheItem> */}
          <DetalheItem><MdBedroomChild size={24} /> {imovel.quartos} Dormitórios</DetalheItem>
          {/* <DetalheItem>{imovel.suites} Suítes</DetalheItem> */}
          <DetalheItem><MdBathroom size={24} /> {imovel.banheiros} Banheiros</DetalheItem>
          <DetalheItem><FaCar size={24} /> {imovel.vagas} Vagas</DetalheItem>
          {/* <DetalheItem>Construído em {imovel.anoConstrucao}</DetalheItem>
          <DetalheItem>Construtora: {imovel.construtora}</DetalheItem> */}
        </Detalhes>

        <Acoes>
          <div>Gostaria de tirar suas dúvidas ou agendar uma visita?</div>
          <a href="https://api.whatsapp.com/send?phone=5565999860053" target="_blank" rel="noopener noreferrer" >
            <Button>Falar no WhatsApp</Button>
          </a>
        </Acoes>
      </InfoPrincipal>

      <Descricao>
        <h3>Descrição do Imóvel</h3>
        <p>{imovel.descricao}</p>
      </Descricao>

      <Localizacao>
        <h3>Localização</h3>
        <p>{imovel.endereco}</p>
        <MapContainer center={[imovel.latitude, imovel.longitude]} zoom={15} style={{ height: "400px", width: "100%" }}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
          <Marker position={[imovel.latitude, imovel.longitude]} icon={icon}>
            <Popup>imovel.endereco</Popup>
          </Marker>
        </MapContainer>

      </Localizacao>
    </Container>
  );
};

export default ImovelPage;
